import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TUpdatePartnerInfoRequest,
  TUpdatePartnerInfoResponse,
} from "./updatePartnerInfo.schema";

export const updatePartnerInfo = (axios: IAxiosInstance) => {
  return async (data: TUpdatePartnerInfoRequest) => {
    const { whiteLabelID, ...rest } = data;

    const response = await axios.noRetry.patch<
      IApiResponse<TUpdatePartnerInfoResponse>
    >(`/api/partners/${whiteLabelID}/info`, rest);

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
